import enCompanySettings from './en';
import ruCompanySettings from './ru';

export default {
  en: {
    ...enCompanySettings,
  },
  ru: {
    ...ruCompanySettings,
  },
};
